import { DashboardDetails } from '../models/dashboard-details';
import { CreateDashboardRequest } from '../models/dashboard-requests';

export function buildCreateDashboardRequest(dashboard: DashboardDetails): CreateDashboardRequest {
    return {
        name: dashboard.name,
        description: dashboard.description,
        abbreviation: dashboard.abbreviation,
        allowInfiniteHScroll: dashboard.allowInfiniteHScroll,
        allowInfiniteVScroll: dashboard.allowInfiniteVScroll,
    };
}
